export const accessLevelOrder = { none: 0, reader: 1, editor: 2 }

export function hasRole(store, roleName) {
  const profile =
    (store && store.getters && store.getters.getProfile) ||
    (store && store.state && store.state.user && store.state.user.user) ||
    {}
  const rawAdm = store.getters.getAdmRoles || profile.adm_roles || []
  const admRoles = Array.isArray(rawAdm) ? rawAdm.map(r => r && r.name).filter(Boolean) : []
  return admRoles.includes(roleName)
}

export function canAction(store, check, requirements = []) {
  const profile =
    (store && store.getters && store.getters.getProfile) ||
    (store && store.state && store.state.user && store.state.user.user) ||
    {}
  if (!profile.use_action_permissions) return true

  const checks = Array.isArray(check) ? check : [check]
  const reqs   = Array.isArray(requirements) ? requirements : [requirements]

  const rawAdm = store.getters.getAdmRoles || profile.adm_roles || []
  const admRoles = Array.isArray(rawAdm) ? rawAdm.map(r => r && r.name).filter(Boolean) : []
  const perms = Array.isArray(profile.screen_action_permissions)
    ? profile.screen_action_permissions
    : []

  return checks.every(item => {
    const isAdmRole = admRoles.includes(item)
    const hasPerm = isAdmRole || perms.some(p => p.action === item)
    if (!hasPerm) return false

    if (reqs.length === 0) return true

    return reqs.every(req => {
      if (Object.prototype.hasOwnProperty.call(accessLevelOrder, req)) {
        const perm = perms.find(p => p.action === item)
        if (!perm) {
          return hasRole(store, item)
        }
        const userLvl = accessLevelOrder[perm.access_level] || 0
        return userLvl >= accessLevelOrder[req]
      }

      return hasRole(store, req)
    })
  })
}